<!-- <table style="width: 100%;">
<tbody>
  <tr *ngFor="let keys of shortcuts">
    <td>{{ keys.key_name | uppercase}}</td>
    <td class="text-right"> {{ keys.screen_name }}</td>
  </tr>
</tbody>
</table> -->
<div class="screen-sh-container">
  @for (keys of shortcuts; track keys) {
    <div class="screen-sh-content">
      <div class="keys-shortcut">
        {{ keys.key_name | uppercase}}
      </div>
      <div class="keys-shortcut-label">
        {{ keys.screen_name }}
      </div>
    </div>
  }
</div>
